const initialState = {
    app: {
        name: '',
        types: [
            {
                logo: '',
                appname: '',
            }
        ],
        applogo: ''
    },
    listAppUnique: [],
    listApp: [],
    spinner: true,
    spinnerViewProfile: true,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_INPUT_CHANGE_APP':
            return Object.assign({}, state, {
                app: {
                    ...state.app,
                    [action.name]: action.value
                }
            })
        case 'LIST_APP':
            return {
                ...state,
                listApp: action.payload,
                spinner: action.spinner,
                spinnerViewProfile: action.spinner
            }
        case 'LIST_APP_UNIQUE':
            return {
                ...state,
                listAppUnique: action.payload,
                spinner: action.spinner
            }
        case 'VIEW_APP':
            return Object.assign({}, state, {
                app: action.payload,
                spinner: action.spinner
            })
        case 'APP_SPINNER':
            return Object.assign({}, state, {
                spinner: true
            })
        case 'EMPTY_APP':
            return Object.assign({}, state, {
                app: {
                    name: '',
                    sortorder: '',
                    types: [
                        {
                            logo: '',
                            appname: '',
                            inputtype: '',
                        }
                    ],
                },
                spinner: false
            })

        default:
            return state;
    }
}